import { useState, useEffect } from 'react';
import api from '../services/api';
import Sidebar from '../components/Sidebar';

export default function Usuarios() {
  const [usuarios, setUsuarios] = useState([]);
  const [form, setForm] = useState({ nome: '', email: '', senha: '', perfil: 'comercial' });
  const [mostrarForm, setMostrarForm] = useState(false);

  useEffect(() => { carregar(); }, []);

  async function carregar() {
    const res = await api.get('/auth/usuarios');
    setUsuarios(res.data);
  }

  async function salvar() {
    await api.post('/auth/usuarios', form);
    setForm({ nome: '', email: '', senha: '', perfil: 'comercial' });
    setMostrarForm(false);
    carregar();
  }

  async function desativar(id) {
    if (window.confirm('Desativar este usuário?')) {
      await api.delete(`/auth/usuarios/${id}`);
      carregar();
    }
  }

  const corPerfil = { master: '#7b1fa2', comercial: '#1976d2', analise: '#f57c00' };

  return (
    <div style={styles.container}>
      <Sidebar />
      <div style={styles.conteudo}>
        <div style={styles.header}>
          <h1 style={styles.titulo}>Usuários</h1>
          <button style={styles.botaoNovo} onClick={() => setMostrarForm(true)}>+ Novo Usuário</button>
        </div>

        {mostrarForm && (
          <div style={styles.form}>
            <h3 style={styles.formTitulo}>Novo Usuário</h3>
            <div style={styles.grid}>
              <div style={styles.campo}>
                <label style={styles.label}>Nome *</label>
                <input style={styles.input} value={form.nome} onChange={e => setForm({ ...form, nome: e.target.value })} />
              </div>
              <div style={styles.campo}>
                <label style={styles.label}>Email *</label>
                <input style={styles.input} type="email" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} />
              </div>
              <div style={styles.campo}>
                <label style={styles.label}>Senha *</label>
                <input style={styles.input} type="password" value={form.senha} onChange={e => setForm({ ...form, senha: e.target.value })} />
              </div>
              <div style={styles.campo}>
                <label style={styles.label}>Perfil *</label>
                <select style={styles.input} value={form.perfil} onChange={e => setForm({ ...form, perfil: e.target.value })}>
                  <option value="comercial">Comercial</option>
                  <option value="analise">Análise</option>
                  <option value="master">Master</option>
                </select>
              </div>
            </div>
            <div style={styles.formBotoes}>
              <button style={styles.botaoSalvar} onClick={salvar}>Salvar</button>
              <button style={styles.botaoCancelar} onClick={() => setMostrarForm(false)}>Cancelar</button>
            </div>
          </div>
        )}

        <table style={styles.tabela}>
          <thead>
            <tr>
              {['Nome', 'Email', 'Perfil', 'Status', 'Ações'].map(h => (
                <th key={h} style={styles.th}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {usuarios.map(u => (
              <tr key={u.id} style={styles.tr}>
                <td style={styles.td}>{u.nome}</td>
                <td style={styles.td}>{u.email}</td>
                <td style={styles.td}>
                  <span style={{ ...styles.badge, backgroundColor: corPerfil[u.perfil] + '22', color: corPerfil[u.perfil] }}>
                    {u.perfil}
                  </span>
                </td>
                <td style={styles.td}>
                  <span style={{ ...styles.badge, backgroundColor: u.ativo ? '#e8f5e9' : '#ffeeee', color: u.ativo ? '#388e3c' : '#e53935' }}>
                    {u.ativo ? 'ativo' : 'inativo'}
                  </span>
                </td>
                <td style={styles.td}>
                  {u.email !== 'master@sistema.com' && (
                    <button style={styles.botaoDesativar} onClick={() => desativar(u.id)}>Desativar</button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

const styles = {
  container: { display: 'flex', height: '100vh', backgroundColor: '#f0f2f5' },
  conteudo: { flex: 1, padding: '2.5rem', overflowY: 'auto' },
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem' },
  titulo: { fontSize: '22px', color: '#1a1a2e', margin: 0 },
  botaoNovo: { backgroundColor: '#1a1a2e', color: '#fff', border: 'none', padding: '10px 18px', borderRadius: '6px', fontSize: '14px', cursor: 'pointer' },
  form: { backgroundColor: '#fff', padding: '1.5rem', borderRadius: '8px', marginBottom: '1.5rem', border: '1px solid #e0e0e0' },
  formTitulo: { margin: '0 0 1rem', fontSize: '16px', color: '#1a1a2e' },
  grid: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' },
  campo: { display: 'flex', flexDirection: 'column' },
  label: { fontSize: '12px', color: '#555', marginBottom: '4px' },
  input: { padding: '9px 12px', borderRadius: '6px', border: '1px solid #ddd', fontSize: '14px' },
  formBotoes: { display: 'flex', gap: '10px', marginTop: '1rem' },
  botaoSalvar: { backgroundColor: '#1a1a2e', color: '#fff', border: 'none', padding: '10px 20px', borderRadius: '6px', fontSize: '14px', cursor: 'pointer' },
  botaoCancelar: { backgroundColor: 'transparent', color: '#888', border: '1px solid #ddd', padding: '10px 20px', borderRadius: '6px', fontSize: '14px', cursor: 'pointer' },
  tabela: { width: '100%', borderCollapse: 'collapse', backgroundColor: '#fff', borderRadius: '8px', overflow: 'hidden' },
  th: { padding: '12px 16px', textAlign: 'left', fontSize: '12px', color: '#888', borderBottom: '1px solid #f0f0f0', fontWeight: '500' },
  tr: { borderBottom: '1px solid #f0f0f0' },
  td: { padding: '12px 16px', fontSize: '14px', color: '#333' },
  badge: { padding: '4px 10px', borderRadius: '20px', fontSize: '12px', fontWeight: '500' },
  botaoDesativar: { backgroundColor: 'transparent', color: '#e53935', border: '1px solid #e53935', padding: '5px 12px', borderRadius: '4px', fontSize: '12px', cursor: 'pointer' },
};